import { render, staticRenderFns } from "./reports-required-skills-by-person.vue?vue&type=template&id=73d424ec"
import script from "./reports-required-skills-by-person.vue?vue&type=script&lang=js"
export * from "./reports-required-skills-by-person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports